module.exports = __webpack_public_path__ + "static/media/rect1.fe132405.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/image/rect1.png
// module id = 1176
// module chunks = 0